let SocialMediaLinksData = [{
    "url": "https://www.youtube.com/@pix-byte-in",
    "classname": "fa fa-youtube-play pb-footer-social-link"
}, {
    "url": "https://www.linkedin.com/in/jithin-v-raj-6153821a1",
    "classname": "fa fa-linkedin pb-footer-social-link"
}, {
    "url": "https://x.com/pix_byte_",
    "classname": "fa fa-twitter pb-footer-social-link"
}, {
    "url": "https://www.instagram.com/pix.byte",
    "classname": "fa fa-instagram pb-footer-social-link"
}, {
    "url": "https://www.facebook.com/pixbytepage",
    "classname": "fa fa-facebook-f pb-footer-social-link"
}, {
    "url": "https://github.com/pix-byte-business",
    "classname": "fa fa-github pb-footer-social-link"
}, {
    "url": "https://whatsapp.com/channel/0029VbCuwmwIHphCKaYb9c35",
    "classname": "fa fa-whatsapp pb-footer-social-link"
}, {
    "url": "https://whatsapp.com/channel/0029VbDZ2e9LY6dAybX0LR1s",
    "classname": "fa fa-whatsapp pb-footer-social-link"
}]

export default SocialMediaLinksData
